import React from "react";
import Button from "./Button";
import FullPageLoader from "./fullPageLoader";

const CommonModal = ({
  isOpen,
  title,
  message,
  confirmButtonText = "Confirm",
  cancleButtonText = "Cancel",
  onConfirm,
  onCancel,
  isFullPageLoading,
  icon,
}) => {
  if (!isOpen) return null;

  const handleContentClick = (e) => {
    e.stopPropagation();
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-in fade-in duration-200">
      {isFullPageLoading && <FullPageLoader />}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onCancel}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-96 w-full overflow-hidden animate-in zoom-in-95 duration-200" onClick={handleContentClick}>
        <div className="h-1.5 bg-brand-gradient" />

        <div className="p-6">
          <div className="flex justify-center mb-3">
            <div className="w-12 h-12 rounded-full bg-brand-gradient flex items-center justify-center text-white">
              {icon}
            </div>
          </div>

          <h3 className="md:text-2xl text-xl font-medium text-gray-900 text-center mb-3">
            {title}
          </h3>

          <p className="text-gray-600 md:text-base text-sm text-center leading-relaxed mb-3">
            {message}
          </p>

          <div className="flex gap-3 justify-center">
            <Button fullWidth onClick={onConfirm}>
              {" "}
              {confirmButtonText}
            </Button>
            <Button fullWidth variant="secondary" onClick={onCancel}>
              {cancleButtonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonModal;
